import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

//styles
import { useStyles } from "./styles";

//types
import { ParentHistoryItem } from "../../../../../store/admin/subAffParent";

interface ISubAffParentHistoryDescriptionProps {
  data: any;
}

const prefix = "admin.partners.account.subAffiliate.parent_affiliate.history.description";

const SubAffParentHistoryDescription: React.FC<ISubAffParentHistoryDescriptionProps> = ({ data }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const change: ParentHistoryItem['subAffiliateHierarchyChange'] = data?.subAffiliateHierarchyChange;

  if (!change) {
    return null;
  }

  const createdBy = change.createdByUsername || change.createdById || '—';

  const getAction = () => {
    if (!change.newParentId) return 'deleted';
    if (!change.previousParentId) return 'added';
    return 'changed';
  };

  const activation = (
    <>
      , {t(`${prefix}.activation_date`)}{" "}
      <b>{change.validFrom || '—'}</b>,{" "}
      {t(`${prefix}.by_user`)}{" "}
      <b>{createdBy}</b>.
    </>
  );

  switch (getAction()) {
    case "deleted":
      return (
        <Typography className={styles.text} variant="body2" component="p">
          {t(`${prefix}.deleted`)}{" "}
          <b>{change.previousParentId}</b>
          {activation}
        </Typography>
      );
    case "added":
      return (
        <Typography className={styles.text} variant="body2" component="p">
          {t(`${prefix}.added`)}{" "}
          <b>{change.newParentId}</b>
          {activation}
        </Typography>
      );
    default:
      return (
        <Typography className={styles.text} variant="body2" component="p">
          {t(`${prefix}.changed`)}{" "}
          <b>{change.previousParentId}</b>{" "}
          {t("admin.reports.detailed_fin_report.logs.actions.adjustment.to")}{" "}
          <b>{change.newParentId}</b>
          {activation}
        </Typography>
      );
  }
};

export default SubAffParentHistoryDescription;
